<script setup lang="ts">
  import { reactive, computed, onMounted } from "vue";
  import { IconArrowLeft } from "@ui-kit";
  import { StatusBar, TopBar } from "@src/components";
  import { useItemList } from "../logic";
  import { default as NotBindingItem } from "./NotBindingItem.vue";
  import { default as LinkItemDialog } from "./LinkItemDialog.vue";

  const {
    zone_path,
    zone_id,
    item_ids = [],
  } = defineProps<{
    zone_path: string;
    zone_id: string;
    item_ids: string[];
  }>();
  const emit = defineEmits<{ (e: "click:back"): void; (e: "link", item_id: string): void }>();

  const item_list = useItemList();

  const link_state = reactive<{ visible: boolean; item_id: string | null }>({ visible: false, item_id: null });
  const linked_item_ids = reactive<string[]>([]);
  const loaded_item_ids = computed(() => item_ids.filter((id) => id in item_list.state.map));

  const handleClickLink = (item_id: string) => {
    if (linked_item_ids.includes(item_id)) return;

    link_state.item_id = item_id;
    link_state.visible = true;
  };

  const handleClickCloseLinkDialog = () => {
    link_state.item_id = null;
    link_state.visible = false;
  };

  const handleLinkSuccess = () => {
    if (link_state.item_id) {
      linked_item_ids.push(link_state.item_id);
    }
    emit("link", link_state.item_id!);
  };

  onMounted(() => {
    item_list.fetch(item_ids);
  });
</script>

<template>
  <div class="not-binding-item-list" data-testid="not-binding-item-list">
    <StatusBar />
    <TopBar :title="$t('Непривязанные цветомодели')" :subtitle="zone_path" @click:left="emit('click:back')">
      <template #left><IconArrowLeft /></template>
    </TopBar>
    <div v-if="!item_list.isEmpty()" class="not-binding-item-list__content" data-testid="not-binding-item-list-content">
      <NotBindingItem
        v-for="item_id in loaded_item_ids"
        :key="item_id"
        :article="item_list.state.map[item_id].article"
        :title="item_list.state.map[item_id].title"
        :image_url="item_list.state.map[item_id].image_url"
        :color="item_list.state.map[item_id].color"
        :is_linked="linked_item_ids.includes(item_id)"
        @click:link="() => handleClickLink(item_id)"
      />
    </div>
  </div>
  <LinkItemDialog
    :item_id="link_state.item_id ?? ''"
    :zone_id="zone_id"
    :visible="link_state.visible"
    @close="handleClickCloseLinkDialog"
    @link="handleLinkSuccess"
  />
</template>

<style scoped>
  .not-binding-item-list {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .not-binding-item-list__content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 8px;
    overflow-y: auto;
  }
</style>
